//staging
// export const MEDIA_URL =
//   "https://suraapistage.appgrowthcompany.com/media/upload/";
// export const API_URL = "https://suraapistage.appgrowthcompany.com/vendor/";
// export const SOCKET_URL = "wss://suraapistage.appgrowthcompany.com";

//dev
export const API_URL = "https://api.sura-trade.com/vendor/";
export const MEDIA_URL = "https://api.sura-trade.com/media/upload/";
export const SOCKET_URL = "wss://api.sura-trade.com";

//live
// export const API_URL = "https://api.sura-trade.com/vendor";
// export const MEDIA_URL = "https://api.sura-trade.com/media/upload/";
// export const SOCKET_URL = "wss://api.sura-trade.com";

export const END_POINTS = {
  //auth
  login: "vendor_login/",
  signUp: "vendor_signup/",
  logout: "vendor_logout/",
  verifyOtp: "vendor_verify-otp/",
  profile: "vendor_profile-update/",
  verifyEmailPhone: "verify-email-phone-no/",
  resendOtp: "vendor_reset-otp/",
  getProfile: "vendor-details-by-token/",
  forgotPass: "vendor_forgot-password/",
  resetPass: "vendor_reset-password/",
  updateBank: "vendor-bank-address-detials-update/",

  //dashboard
  dashboard: "get-dashboard-data/",
  orderGraph: "get-vendor-order-graph-data/",
  revenueGraph: "get-vendor-revenue-graph-data/",
  bestSellingGraph: "get-vendor-best-selling-list-data/",

  //product
  addProduct: "add-product/",
  getCategory: "get-all-category/",
  getSubCategory: "get-sub-category-by-category-id/",
  getAllProducts: "get-all-manage-product/",
  getProductById: "get-manage-product/",
  updateProduct: "update-manage-product/",
  deleteProduct: "delete-manage-product/",
  productViews: "product-count-other-details/",

  // orders
  getOrders: "get-all-manage-order/",
  deleteOrders: "delete-manage-order/",
  getOrderById: "get-manage-order/",
  orderStatus: "update-manage-order-status/",

  //settings
  vendorTime: "vendor-time-cms/",
  getVendorCms: "vendor-get-cms/",
  adminCms: "admin-cms/",

  //return exchange
  returnExchangeListings: "get-all-manage-return-exchaneg-order/",
  exchangeById: "get-return-exchange-manage-order",
  deletById: "delete-return-exchange-manage-order/",
  orderStatusUpdate: "update-return-exchange-manage-order-status/",
  exchangeAcceptReject: "vedor-exchange-request-acc-rej/",
  returnAcceptReject: "vedor-return-request-acc-rej/",
  setRefundAmount: "set-amount-return-exchange-manage-order/",

  // banner
  addDiscount: "add-discount/",
  discountListing: "get-all-manage-discount/",
  discountByid: "get-manage-discount/",
  deleteDiscount: "delete-manage-discount/",
  updateDiscount: "update-details/",

  //discount
  addCoupon: "add-discount_coupon/",
  getAllCoupon: "get-all-manage-discount_coupon/",
  updateCoupon: "update-discount-details_coupon/",
  getCouponById: "get-manage-discount_coupon/",
  deleteCoupon: "delete-manage-discount_coupon/",

  //quote
  getAllQuotes: "vendor-quotes/",
  revertQuote: "vendor-quotes-revert/",

  //chat
  chatList: "vendor-chat/sessions/",
  chatHistory: "chat-history-by-session/",

  //faq
  allFaq: "vendor-get-all-faq/",
  addFaq: "vendor-add-faq/",
  deleteFaq: "vendor-faq-delete/",

  //ratings
  rating: "get-all-manage-rating/",
  ratingResponse: "vendor-review-response/",

  //payments
  paymentDashboard: "vendor-payments-dashboard/",
  paymentHistory: "vendor-order-payments-history/",
  paymentRequest: "vendor-payment_withdraw-request/",

  //notification
  addNotification: "vendor-add/notification/",
  allNotifications: "vendor-all-notifications/",
  deleteNotification: "vendor-delete-notification/",

  //support
  allSupport: "vendor-query-listing/",
  revertSupport: "vendor-query-revert/",
};
